/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-unused-class-component-methods */
import React from 'react'
import { Animated } from 'react-native'
import { delay } from 'x/utils/util'
import api from 'x/utils/api'

import CONS from 'x/config/constants'
import _ from 'lodash'
import p from 'x/config/platform-specific'
import * as util from 'x/utils/util'
import {
  ActionApiParams,
  ISelectedStoreMap,
  IMKPChannelDetail,
  IBgSyncStatusManager,
  IOverlaySetupSyncOrderCallBack,
  IBackgroundJobListResponse,
  IProductGroup,
  IQuestionsAndAnswers,
  IShippingType,
  IAddress,
  // IBackgroungJob,
  IXScreenProps,
  ISelectedStore,
  IProductDetailItem,
  IOrderProductItem,
  IProductBundlesDetailViewNavParams,
  IProductBundle,
} from 'x/types'
import { isImmutable } from 'immutable'
// import { IBackgroungJob } from 'x/types'
import * as NavActions from 'x/utils/navigation'
import { canDoAtSelectedStore } from 'x/utils/acl'


interface IBaseProductBundlesDetailViewProps extends IXScreenProps<IProductBundlesDetailViewNavParams> {
  // nothing for now
}

interface IBaseProductBundlesDetailViewState {
  isLoading: boolean
  loadingWidth: number
  loadingHeight: number
  productBundles: IProductBundle[]

  showProfit: boolean
  product: IOrderProductItem
}

const { BACKGROUND_JOB_TYPES } = CONS

export default abstract class BaseProductBundlesDetailView extends React.Component<
  IBaseProductBundlesDetailViewProps,
  IBaseProductBundlesDetailViewState
> {
  // abstract async handleSubmitForm(response: any): Promise<void>
  // abstract goBackFromBase: () => void
  // MKP_IDS: number[]

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      loadingWidth: 0,
      loadingHeight: 0,
      productBundles: null,
      showProfit: false,
      product: null,
    }
  }

  componentDidMount() {
    this._setProductBundles()
  }

  _goBack = () => {
    // @ts-ignore
    util.navGoBack(this.props)
  }

  _setProductBundles = () => {
    // @ts-ignore
    const params = util.getNavParams(this.props)
    const { product, showProfit, productBundles } = params
    const product_bundle_id = product?.product_bundle_id
    const newProductBundles = []
    productBundles.forEach((item) => {
      if (item.product_bundle_id === product_bundle_id) {
        newProductBundles.push(item)
      }
    })
    console.log('newProductBundles => ', newProductBundles)
    this.setState({ productBundles: newProductBundles, showProfit, product })
  }

  // componentWillUnmount() {
  // this.isStopSyncFunctionLoop = true
  // }
}
